import 'bootstrap-daterangepicker/daterangepicker.css';
import './_range.scss';
import './_range.dark-mode.scss';
import React, { useRef, useEffect, useState, cloneElement } from 'react';
import PropTypes from 'prop-types';
import $ from 'jquery';
import moment from 'moment';

import '../../../services/libs/bootstrap-daterangepicker';

const RangePicker = ({
  children,
  onChange,
  onApply,
  defStartDate,
  defEndDate,
  parentEl,
  hidden,
  opens,
  maxSelection,
  showDropdowns,
  linkedCalendars,
  minDate,
  maxDate,
}) => {
  const ref = useRef(null);

  const [date, setDate] = useState({
    startDate: moment(new Date(defStartDate)).format('YYYY-MM-DD'),
    endDate: moment(new Date(defEndDate)).format('YYYY-MM-DD'),
  });

  useEffect(() => {
    let prepareOptions = {
      startDate: date.startDate,
      endDate: date.endDate,
      maxDate: maxDate || new Date(),
      linkedCalendars,
      showDropdowns,
      minDate,
      opens,
      locale: {
        format: 'YYYY-MM-DD',
        separator: ' — ',
      },
      parentEl,
    };

    if (maxSelection) {
      prepareOptions = { ...prepareOptions, maxSpan: { days: maxSelection } };
    }

    $(ref.current)
      .daterangepicker(prepareOptions, (start, end) => {
        setDate({
          startDate: start.format('YYYY-MM-DD'),
          endDate: end.format('YYYY-MM-DD'),
        });
        onChange
          && onChange({
            startDate: start.format('YYYY-MM-DD'),
            endDate: end.format('YYYY-MM-DD'),
          });
      })
      .on('apply.daterangepicker', (_, picker) => {
        setDate({
          startDate: picker.startDate.format('YYYY-MM-DD'),
          endDate: picker.endDate.format('YYYY-MM-DD'),
        });

        onApply
          && onApply({
            startDate: picker.startDate.format('YYYY-MM-DD'),
            endDate: picker.endDate.format('YYYY-MM-DD'),
          });
      });

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      $(ref.current).data('daterangepicker').remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (children) {
    return cloneElement(children, { ref, id: 'datePicker' });
  }

  return <input className="form-control" id="datePicker" ref={ref} style={{ display: hidden ? 'none' : 'block' }} />;
};

RangePicker.propTypes = {
  children: PropTypes.any,
  onChange: PropTypes.func,
  onApply: PropTypes.func,
  defStartDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  defEndDate: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  parentEl: PropTypes.string,
  hidden: PropTypes.bool,
  opens: PropTypes.string,
  maxSelection: PropTypes.number,
  showDropdowns: PropTypes.bool,
  linkedCalendars: PropTypes.bool,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
};

RangePicker.defaultProps = {
  defStartDate: moment().subtract(7, 'd'),
  defEndDate: moment(),
  parentEl: 'body',
  opens: 'left',
  hidden: false,
  showDropdowns: false,
  linkedCalendars: true,
};

export default RangePicker;
